import { useRef } from "react";

import Banner from "./Banner";
import JobInformation from "./JobInformation";
import FormSection from "./FormSection";

const JobDetails = () => {
  const applyFormRef = useRef(null);

  return (
    <>
      <div className="bg-white text-gray-800"> 
       <Banner
          config={{
            applyFormRef,
            title: "React Developer",
          }}
        />

        <div className="bg-white px-6 md:px-16 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">

            <div className="lg:col-span-2 space-y-12">
              <div>
                <h2 className="text-[32px] font-semibold text-[#212129] mb-6">
                  Job Summary
                </h2>

                <p className="text-[#212129] text-[18px] leading-8 mb-6">
                  We are on the hunt for a motivated and detail-oriented React
                  Developer (Fresher) to join our front-end development team.
                  The ideal candidate should have a solid understanding of
                  JavaScript, React fundamentals, and a desire to build
                  engaging, high-performance user interfaces.
                </p>
              </div>

              <div>
                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Key Responsibilities
                </h3>
                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>
                    Assist in building responsive, dynamic web applications
                    using React.
                  </li>
                  <li>
                    Collaborate with backend developers to integrate APIs.
                  </li>
                  <li>
                    Write clean, maintainable, and reusable code using modern
                    JavaScript (ES6+).
                  </li>
                  <li>Optimize components for performance and scalability.</li>
                  <li>
                    Work with designers to translate UI/UX wireframes into
                    actual code.
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Qualifications
                </h3>
                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>
                    Bachelor’s degree in Computer Science, IT, Engineering, or a
                    related field.
                  </li>
                  <li>(Eligible: B.Sc (CS/IT), B.E/B.Tech, BCA, MCA).</li>
                  <li>
                    Basic knowledge of web development and React concepts.
                  </li>
                  <li>
                    Internship or academic project experience with React is a
                    plus.
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Skills & Competencies
                </h3>
                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>Proficiency in React.js, JavaScript (ES6+), and JSX.</li>
                  <li>
                    Understanding of component-based architecture and state
                    management (e.g., Hooks, Context API).
                  </li>
                  <li>Familiarity with HTML5, CSS3, and responsive design.</li>
                  <li>
                    Knowledge of REST APIs and asynchronous JavaScript (AJAX,
                    Fetch).
                  </li>
                  <li>
                    Exposure to tools like Git, npm/yarn, and browser dev tools.
                  </li>
                  <li>Strong problem-solving and debugging skills.</li>
                  <li>Effective communication and collaboration skills.</li>
                </ul>
              </div>
            </div>
            <JobInformation />
          </div>
        </div>
      </div>

      <FormSection applyFormRef={applyFormRef} />
    </>
  );
};

export default JobDetails;
